import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {first, pairwise, startWith} from "rxjs/operators";
import {CustomerService} from "../../customer.service";
import {MatSliderChange} from "@angular/material/slider";
import {formatCurrency} from "@angular/common";
import { Subscription, filter } from 'rxjs';
import {SharedService} from "../../../shared/shared.service";
import {CurrencyMaskOptions} from "../../../shared/shared.constants";
import { NotOnlySpaces } from '../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import {StaffService} from "../../../../services/staff/staff.service";
import {CoreService} from "../../../../services/core/core.service";
import {UserService} from "../../../../services/core/user.service";
import {TermService} from "../../../setting/term/term.service";
import {SettingDataService} from "../../../setting/setting.data.service";

@Component({
    selector: 'app-admin-information',
    templateUrl: './admin-information.component.html',
    styleUrls: ['./admin-information.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AdminInformationComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AdminInformationComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AdminInformationComponent implements OnInit {

  @Input() model: any = null;
  @Input() isEdit = false;
  @Input() form: any = {};
  @Output() onInitForm = new EventEmitter<any>(true);
  @Output() callback = new EventEmitter<any>(true);

  public risk_level: any = 0;
  public paymentMethods: string[] = [];
  public staffs: any[] = [];
  public taxAndDiscountClasses: string[] = [];
  public sources: object[] = [{id:1, name: 'Source 001'}, {id:2, name: 'Source 002'}];
  public customerTerms: any[] = [];
  /** Show Preferred Mark Up field only when customer setting Is_set_preffered_markup is true */
  public showPreferredMarkup = false;
  /** Show Lien Period field only when customer setting Is_set_lien_period is true */
  public showLienPeriod = false;
  //@ts-ignore
  public adminInformationSubscription: Subscription;
  public currencyMaskOptions = CurrencyMaskOptions;

  public adminInformation: UntypedFormGroup = new UntypedFormGroup({
    sales_rep_id: new UntypedFormControl(null, [Validators.required]),
    tax_exempt: new UntypedFormControl(0),
    payment_method: new UntypedFormControl(null),
    term_id: new UntypedFormControl(null),
    markup: new UntypedFormControl(null),
    // tax_class:new FormControl(null),
    //  disc_class:new FormControl(null),
    source: new UntypedFormControl(null),
    lien_period: new UntypedFormControl(null),
    risk: new UntypedFormControl(null),
    risk_level: new UntypedFormControl(null),
    // tenant_id:new UntypedFormControl('',[Validators.required,NotOnlySpaces()]),
    // tenant_ids:new UntypedFormControl(null)
  });

  public offices: string[] = [];
  public subOffices: string[] = [];

  constructor(
    private customerService:CustomerService,
    public sharedService: SharedService,
    public staffService: StaffService,
    public coreService: CoreService,
    private currentUser: UserService,
    private termService: TermService,
    private settingDataService: SettingDataService
  ) { }


  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
    this.onModelValueChanged  = this.model?.model?.admin_info;

  }

  ngOnInit(): void {
    this.initSubscriptions()
    this.getPaymentMethods({});
    this.getTaxAndDiscountClasses();
    // this.getSources({});
    this.getStaffs();
    this.initFormValues();
    // this.getOffices();
    this.getSources();
    this.getCustomerTerms();
    this.getCustomerSettingMarkup();
  }

  /** Use Customer Setting (Markup Settings) to pre-fill Preferred Mark Up when status is ON. */
  getCustomerSettingMarkup(): void {
    this.settingDataService.getCustomerSettings()
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          const data = response?.data;
          const isSetPreferredMarkup = !!data?.Is_set_preffered_markup;
          const isSetLienPeriod = !!data?.Is_set_lien_period;

          this.showPreferredMarkup = isSetPreferredMarkup;
          this.showLienPeriod = isSetLienPeriod;

          if (!this.isEdit) { 
            if (isSetPreferredMarkup) {
              const markupValue = data?.preferred_markup;
              if (markupValue != null && markupValue !== '') {
                this.adminInformation.get('markup')?.setValue(markupValue);
              }
            }
            if (isSetLienPeriod) {
              const lienPeriodValue = data?.lien_period;
              if (lienPeriodValue != null && lienPeriodValue !== '') {
                this.adminInformation.get('lien_period')?.setValue(lienPeriodValue);
              }
            }
          }
          this.onInitForm.emit(this.adminInformation);
        },
      });
  }

  initFormValues(){
    if (this.isEdit) {
      this.adminInformation.get('sales_rep_id')?.clearValidators();
      this.adminInformation.get('sales_rep_id')?.updateValueAndValidity(); // To revalidate after clearing
    }

    this.adminInformation.get('tax_exempt')?.setValue(this.onModelValueChanged?.tax_exempt ? true : false);
    this.adminInformation.get('markup')?.setValue(this.onModelValueChanged?.markup ? this.onModelValueChanged?.markup : '');
    this.adminInformation.get('lien_period')?.setValue(this.onModelValueChanged?.lien_period ?  this.onModelValueChanged?.lien_period : 0);
    this.adminInformation.get('risk_level')?.setValue(this.onModelValueChanged?.risk ?   this.onModelValueChanged?.risk : 0);
    this.adminInformation.get('risk')?.setValue(this.onModelValueChanged?.risk ?   this.onModelValueChanged?.risk : 0);
    this.adminInformation.get('source')?.setValue(this.onModelValueChanged?.source ?    this.onModelValueChanged?.source : null);
    this.onInitForm.emit(this.adminInformation);
  }
  setPaymentMethodValue(){
    const paymentMethod = this.paymentMethods.find((x:any) => x.id == this.onModelValueChanged?.default_payment_method);
    if(paymentMethod){
      this.adminInformation.get('payment_method')?.setValue(paymentMethod);
      this.onInitForm.emit(this.adminInformation);
    }

  }
  public onModelValueChanged:any = {};



  onInputChange(event: MatSliderChange) {
    // const value = formatCurrency(event.value != null ? event.value : 0,'en-US','$','USD','1.2-2');
    this.adminInformation.controls['risk_level'].setValue(event.value);
    // console.log(2, this.adminInformation?.get('risk_level')?.value);
  }

  onValueInput(event: any){
    const risk_level = this.adminInformation.controls['risk_level']?.value;
    // this.adminInformation.controls['risk'].setValue(risk_level.toString().replace(',',''));
    this.adminInformation.controls['risk'].setValue(risk_level);
  }

  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return String(value);
  }

  getPaymentMethods = (queryParam: any) => {
    this.customerService.getPaymentMethods(queryParam)
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.paymentMethods = data.data.map((group:any)=>{
            return {id: group.id, name: group.name};
          });
          this.setPaymentMethodValue();
        });
  }
  getStaffs = () => {
    this.sharedService.getStaffs()
      .pipe(first())
      .subscribe(
        (data:any) => {
          let currentStaffList: any = [];
          this.staffs =  this.staffService.processStaff(data.data,currentStaffList);
          const currentUserID = this.currentUser?.getID();
          if (currentUserID){
            this.adminInformation?.get('sales_rep_id')?.setValue(this.staffService.getStaffById(this.staffs, currentUserID));
          }
        });
  }
  getTaxAndDiscountClasses = () => {
    this.customerService.getPaymentMethods({})
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.taxAndDiscountClasses = data.data.map((group:any)=>{
            return {id: group.id, name: group.name};
          });
        });
  }

  getSources = () => {
    this.sharedService.getSources()
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.sources = data.data.map((source:any)=>{
            return {id: source.id, name: source.name};
          });
        });
  }

  getCustomerTerms = () => {
    this.termService.termDataService.getByModule('13') // Customer module ID = 1
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.customerTerms = data.data.map((term:any)=>{
            return {id: term.id, name: term.name};
          });
          this.setTermValue();
        });
  }

  setTermValue(){
    console.log('Setting term value, onModelValueChanged:', this.onModelValueChanged);
    console.log('Available customer terms:', this.customerTerms);
    
    // First check if we already have the term object from backend
    let termToSet = this.onModelValueChanged?.term;
    
    // If not, try to find by term_id
    if (!termToSet) {
      const termId = this.onModelValueChanged?.term_id || 
                     this.onModelValueChanged?.terms_id || 
                     this.model?.model?.term_id ||
                     this.model?.model?.terms_id;
      
      console.log('Looking for term_id:', termId);
      
      if (termId) {
        termToSet = this.customerTerms.find((x:any) => x.id == termId);
      }
    }
    
    console.log('Term to set:', termToSet);
    
    if(termToSet){
      this.adminInformation.get('term_id')?.setValue(termToSet);
      this.onInitForm.emit(this.adminInformation);
    }
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.adminInformation.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.adminInformation.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.adminInformation.disable() : this.adminInformation.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.adminInformation.valid ? null : { invalidForm: {valid: false, message: "Admin Information fields are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.adminInformationSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched){
            this.touchFormControls();
          }
        });
    }

  }
  touchFormControls(){
    Object.keys(this.adminInformation.controls).forEach(key => {
      this.adminInformation.get(key)?.markAsTouched();
    });
  }
  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.adminInformationSubscription?.unsubscribe();
  }

}
